import Vue from 'vue'
import {
  Dialog,
  Container,
  Header,
  Main,
  Aside,
  Tag,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  Row,
  Col,
  Scrollbar,
  Switch,
  Select,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Option,
  OptionGroup,
  Button,
  RadioButton,
  ButtonGroup,
  Table,
  TableColumn,
  Form,
  FormItem,
  Loading,
  MessageBox,
  Message,
  Notification,
  Slider,
  TimePicker,
  Progress,
  Checkbox,
  Popover,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Drawer,
  Upload,
  Pagination,
  Card,
  CheckboxButton,
  CheckboxGroup,
  Tree,
  Rate,
  Tabs,
  TabPane
  
} from 'element-ui'

import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Slider)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(RadioButton)
Vue.use(Scrollbar)
Vue.use(Checkbox)
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(Row)
Vue.use(Col)
Vue.use(RadioGroup)
Vue.use(TimePicker)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Upload)
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Aside);
Vue.use(Tag);
Vue.use(Pagination);
Vue.use(Card);
Vue.use(Tree);
Vue.use(Rate);
Vue.use(Tabs);
Vue.use(TabPane);


Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
